import { ReactElement } from 'react'
import styles from './MainOurServiceRoundBox.module.scss'

interface MainOurServiceRoundBoxProps {
  message: string
  badgeIcon: ReactElement
  className?: string
}

export default function MainOurServiceRoundBox(props: MainOurServiceRoundBoxProps) {
  const { message, badgeIcon, className='' } = props
  return (
    <div className={ `${className} ${styles.MainOurServiceRoundBox}` }>
      <div className={ `${styles.badge}` }>
        {badgeIcon}
      </div>
      <div className={ styles.message }>
        <p dangerouslySetInnerHTML={ { __html: message } } />
      </div>
    </div>
  )
}
